import { Component, Input, inject } from '@angular/core';
import { Theme } from 'src/app/theme/theme';
import { AvatarPart } from '../../tribe';
import { SelectAvatarService } from '../select-avatar.service';

@Component({
  selector: 'app-select-avatar-item-select',
  templateUrl: './select-avatar-item-select.component.html',
  styleUrls: ['./select-avatar-item-select.component.scss'],
  standalone: false
})
export class SelectAvatarItemSelectComponent {
  private selectAvatarService = inject(SelectAvatarService);

  @Input()
  theme: Theme;

  get currentPartList(): AvatarPart[] {
    return this.selectAvatarService.selectedSlot?.parts ?? [];
  }

  get optional(): boolean {
    if (!this.selectAvatarService.selectedSlot) {
      return false;
    }
    return !this.selectAvatarService.selectedSlot.required;
  }

  onPartSelected(part: AvatarPart) {
    this.selectAvatarService.selectPart(part.id);
  }

  onPartCancel() {
    this.selectAvatarService.cancelPart();
  }

  getPartStyle(part?: AvatarPart) {
    let selected = false;
    const partId = this.selectAvatarService.selectedParts.get(
      this.selectAvatarService.selectedSlot.id
    );
    if (!part) {
      selected = partId === undefined;
    } else {
      selected = partId !== undefined && this.currentPartList[partId].id === part.id;
    }
    return {
      'background-color': selected ? this.theme.primaryColor : this.theme.backgroundColor
    };
  }

  isPartSelected(part?: AvatarPart) {
    const selectedPartId = this.selectAvatarService.selectedParts.get(
      this.selectAvatarService.selectedSlot.id
    );
    if (!part) {
      return selectedPartId === undefined;
    } else {
      return (
        selectedPartId !== undefined &&
        this.selectAvatarService.selectedParts.get(this.selectAvatarService.selectedSlot.id) ===
          part.id
      );
    }
  }
}
